import React, { forwardRef } from 'react'

import { cn } from 'utils'

import {
  TextLikeFormField,
  type TextLikeFormFieldProps,
} from './TextLikeFormField'

export interface TextareaProps
  extends Omit<TextLikeFormFieldProps, 'children' | 'leadingIcon'>,
  React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  placeholder?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>((props, forwardedRef) => {
  return (
    <TextLikeFormField {...props}>
      {(formFieldProps) => (
        <textarea
          {...formFieldProps}
          className={cn(formFieldProps.className, 'block')}
          ref={forwardedRef}
        />
      )}
    </TextLikeFormField>
  )
})
